import { render, staticRenderFns } from "./OwnRatingResult.vue?vue&type=template&id=696bad11&scoped=true"
import script from "./OwnRatingResult.vue?vue&type=script&lang=js"
export * from "./OwnRatingResult.vue?vue&type=script&lang=js"
import style0 from "./OwnRatingResult.vue?vue&type=style&index=0&id=696bad11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696bad11",
  null
  
)

export default component.exports